class ConvertFlowClient {
  constructor(props) {
    this.environment = props.environment
    this.builder = props.builder;

    if (this.environment === 'production') {
      this.redirectUri = "https://app.convertflow.co";
    } else if (this.environment === 'staging') {
      this.redirectUri = "https://staging.convertflow.co";
    } else if (this.environment === 'test') {
      this.redirectUri = window.location?.origin;
    } else {
      this.redirectUri = "http://localhost:3000";
    }

    this.websiteId = props.website_id;
    this.endpoint = `${this.redirectUri}/api/v1`;
    this.clientOptions = {
      headers: { "Content-Type": "application/json" },
    };
  }

  getStoreReviews = async (query = '') => {
    return new Promise((resolve, reject) => fetch(
      `${this.endpoint}/reviews?website_id=${this.websiteId}&builder=${this.builder}&${query}`, this.clientOptions
    ).then(response => {
      response.json().then(resp => {
        resolve(resp)
      }).catch(reject);
    }).catch(reject));
  }
}

if (typeof window !== "undefined" && typeof window.convertflow == "undefined") {
  window.ConvertFlowClient = ConvertFlowClient;
}
